<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="40.47" height="40.47" viewBox="0 0 40.47 40.47">
        <g id="Groupe_140" data-name="Groupe 140" transform="translate(-1138.6 -411.431)">
            <circle
                id="Ellipse_6"
                data-name="Ellipse 6"
                cx="15.237"
                cy="15.237"
                r="15.237"
                transform="translate(1138.927 423.42) rotate(-22.5)"
                fill="none"
                stroke="#5f5f60"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
            />
            <ellipse
                id="Ellipse_7"
                data-name="Ellipse 7"
                cx="8.256"
                cy="15.237"
                rx="8.256"
                ry="15.237"
                transform="translate(1150.579 416.429)"
                fill="none"
                stroke="#5f5f60"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
            />
            <path
                id="Tracé_190"
                data-name="Tracé 190"
                d="M1147.523,441.876c2.537-2.292,6.659-3.783,11.311-3.783s8.774,1.491,11.312,3.783"
                fill="none"
                stroke="#5f5f60"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
            />
            <path
                id="Tracé_191"
                data-name="Tracé 191"
                d="M1147.523,421.457c2.537,2.292,6.659,3.783,11.311,3.783s8.774-1.491,11.312-3.783"
                fill="none"
                stroke="#5f5f60"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
            />
            <line
                id="Ligne_25"
                data-name="Ligne 25"
                x2="30.474"
                transform="translate(1143.598 431.666)"
                fill="none"
                stroke="#5f5f60"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
            />
            <line
                id="Ligne_26"
                data-name="Ligne 26"
                y1="30.474"
                transform="translate(1158.834 416.429)"
                fill="none"
                stroke="#5f5f60"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
            />
        </g>
    </svg>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            required: false,
            default: "#000"
        }
    }
};
</script>



// WEBPACK FOOTER //
// WorldIcon.vue?b8da5e6e